module.exports = __webpack_public_path__ + "static/media/MenuIcon.0771c399.svg";